import StudentInfoTab from "./StudentInfoTab";
import StudentSchoolTab from "./StudentSchoolTab";
import StudentTestTab from "./StudentTestTab";
import StudentSatPlanTab from "./StudentSatPlanTab";
import StudentSessionsTab from "./StudentSessionsTab";
import StudentConferenceTab from "./StudentConferenceTab";
import StudentCalendarTab from "./StudentCalendarTab";

/**
 * Student Detail tab registry.
 *
 * Each tab is a self-contained module. To add, remove, reorder, or rename a tab
 * in the future, edit this single array — the dashboard shell (header, tab nav,
 * routing, and the contextual Save button) is fully driven by this config and
 * needs no changes.
 *
 * Fields
 *  - key:        stable identifier for the tab (used for active-tab state and an
 *                optional initial-tab request via navigation state; tabs do NOT
 *                create their own URL sub-routes)
 *  - label:      Text shown in the tab nav
 *  - component:  React component rendered when the tab is active
 *  - autoSave:   when true, edits made on this tab (which flow through the shared
 *                student form state) are debounced-autosaved by the shell — no
 *                manual Save button. Tabs that persist their own data (Test,
 *                Sessions, Conference, Calendar) manage saving internally and
 *                set this to false.
 *  - description: optional short caption (reserved for future use)
 */
export const STUDENT_TABS = [
  {
    key: "info",
    label: "Info",
    component: StudentInfoTab,
    autoSave: true,
  },
  {
    key: "school",
    label: "School",
    component: StudentSchoolTab,
    autoSave: true,
  },
  {
    key: "test",
    label: "Test",
    component: StudentTestTab,
    autoSave: false,
  },
  {
    key: "plan",
    label: "Plan",
    component: StudentSatPlanTab,
    autoSave: false,
  },
  {
    key: "sessions",
    label: "Sessions",
    component: StudentSessionsTab,
    autoSave: false,
  },
  {
    key: "conference",
    label: "Conference",
    component: StudentConferenceTab,
    autoSave: false,
  },
  {
    key: "calendar",
    label: "Calendar",
    component: StudentCalendarTab,
    autoSave: false,
  },
];

// Sessions is the default landing tab — session activity and progress reports
// are the most important information when opening a student profile.
export const DEFAULT_TAB_KEY = "sessions";

export function normalizeTabKey(tabKey) {
  const raw = String(tabKey || "").trim().toLowerCase();
  return STUDENT_TABS.some((tab) => tab.key === raw) ? raw : DEFAULT_TAB_KEY;
}

export function getTab(tabKey) {
  const key = normalizeTabKey(tabKey);
  return STUDENT_TABS.find((tab) => tab.key === key) || STUDENT_TABS[0];
}
